// extracted by mini-css-extract-plugin
export default {"container":"HTMLText_container__9q98x"};